module.exports = __webpack_public_path__ + "components/media-kit/static/alert-desktop-46ff1e53329fb9f67d87dc8c7567570c.png";